/**
 * Safe, minimal markdown → HTML for CMS-authored inline text.
 * Supports **bold**, *italic*, and [text](url). Nothing else.
 * Escapes HTML first so admin authors can't inject arbitrary markup.
 */

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function safeUrl(u) {
  // Only allow http(s), mailto, tel, and same-origin relative paths.
  const trimmed = String(u || "").trim();
  if (!trimmed) return "#";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^mailto:/i.test(trimmed)) return trimmed;
  if (/^tel:/i.test(trimmed)) return trimmed;
  if (trimmed.startsWith("/")) return trimmed;
  return "#";
}

export function formatCms(text) {
  if (typeof text !== "string" || !text) return "";
  let out = escapeHtml(text);

  // Links first so ** inside labels doesn't collide with URL parsing
  out = out.replace(/\[([^\]\n]+)\]\(([^)\s]+)\)/g, (_, label, url) => {
    const u = safeUrl(url);
    const external = /^https?:\/\//i.test(u);
    const attrs = external ? ' target="_blank" rel="noopener noreferrer"' : "";
    return `<a href="${u}" class="link-quiet"${attrs}>${label}</a>`;
  });

  // Bold — non-greedy, single line
  out = out.replace(/\*\*([^*\n]+?)\*\*/g, "<strong>$1</strong>");
  // Italic — single-star, non-greedy
  out = out.replace(/(^|[^*])\*([^*\n]+?)\*(?!\*)/g, "$1<em>$2</em>");

  // Preserve simple line breaks the admin author typed
  out = out.replace(/\n/g, "<br />");

  return out;
}

/** Returns true if the string contains any of our supported markdown markers. */
export function hasMarkdown(text) {
  if (typeof text !== "string") return false;
  return /\*\*|\*|\[[^\]]+\]\(/.test(text);
}
